import { createApiClient, httpErrorFrom } from '../../api';
import type { PlantProfile, PlantProfilePatch } from '../types';

import { PLANT_ENDPOINTS } from './endpoints';
import { parsePlantDetails, parsePlantName, parsePlantProfile } from './schemas';

const NOT_FOUND_STATUS = 404;

const { request } = createApiClient();

export const fetchPlantProfile = async (plantId: string, signal: AbortSignal | undefined): Promise<PlantProfile> => {
  const profile = parsePlantDetails(await request('get', PLANT_ENDPOINTS.DETAILS, { params: { assetId: plantId }, signal }));
  if (profile === null) throw httpErrorFrom(NOT_FOUND_STATUS, null);
  return profile;
};

export const updatePlantProfile = async (plantId: string, patch: PlantProfilePatch): Promise<PlantProfile> =>
  parsePlantProfile(await request('patch', PLANT_ENDPOINTS.PROFILE(plantId), { body: patch }));

export const fetchPlantName = async (plantId: string, signal: AbortSignal | undefined): Promise<string | null> =>
  parsePlantName(await request('post', PLANT_ENDPOINTS.NAME, { body: { id: plantId }, signal }));
